export default __webpack_public_path__ + "static/media/warning--entering-roadway-merge--g2.86b6aca3.png";